import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "agent-desktop-shell" }
const _hoisted_2 = { class: "agent-desktop-header" }
const _hoisted_3 = { class: "agent-desktop-header-main" }
const _hoisted_4 = { class: "agent-title-wrap" }
const _hoisted_5 = { class: "agent-title-row" }
const _hoisted_6 = { class: "agent-title" }
const _hoisted_7 = {
  key: 0,
  class: "shared-owner-line"
}
const _hoisted_8 = { class: "agent-description" }
const _hoisted_9 = { class: "agent-chip-row" }
const _hoisted_10 = { class: "agent-footer" }
const _hoisted_11 = { class: "agent-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "shared-agent-card",
    color: "background",
    variant: "elevated",
    elevation: "4",
    onClick: _ctx.onCardClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_avatar, {
              size: "48",
              rounded: "lg",
              class: "agent-avatar agent-icon-tile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: _ctx.iconName,
                  size: "small"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.agent.agentName), 1),
                (_ctx.agent.isPublished)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "small",
                      color: "success",
                      variant: "tonal",
                      class: "agent-live-chip"
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" LIVE ")
                      ])),
                      _: 1,
                      __: [1]
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.agent.ownerUsername)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Shared by @" + _toDisplayString(_ctx.agent.ownerUsername), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.agent.description), 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_chip, {
            size: "small",
            variant: "tonal",
            class: "agent-chip"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-earth",
                size: "x-small",
                start: ""
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.modelChipLabel), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, {
            size: "small",
            variant: "outlined",
            class: "agent-chip"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-tools",
                size: "x-small",
                start: ""
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.toolsChipLabel), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "agent-footer-spacer" }, null, -1)),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.publicUrl)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  text: "Open in new window",
                  location: "top"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      color: "secondary",
                      icon: "mdi-open-in-new",
                      size: "small",
                      variant: "plain",
                      href: _ctx.publicUrl,
                      target: "_blank",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }), null, 16, ["href"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.agent.isPublished && _ctx.agent.slug)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 1,
                  text: "Chat with Agent",
                  location: "top"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      color: "primary",
                      icon: "mdi-chat-outline",
                      size: "small",
                      variant: "plain",
                      onClick: _withModifiers(_ctx.goToChat, ["stop"])
                    }), null, 16, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.agent.editable)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 2,
                  text: "Edit Agent",
                  location: "top"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      color: "primary",
                      icon: "mdi-pencil-outline",
                      size: "small",
                      variant: "plain",
                      onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                    }), null, 16, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}